import { useCallback } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';
import { atom } from 'jotai/index';

import { DebugBarEntry } from 'utility/Debug/DevicedDebugbar/types';

import { ExternalCall } from 'proto/DebugBar';

const debugBarAtom = atom<DebugBarEntry[]>([]);

export const useAddDebugBarEntry = () => {
    const setDebugBar = useSetAtom(debugBarAtom);

    return useCallback(
        (name: string, externalCalls: ExternalCall[] | undefined) => {
            externalCalls?.length &&
                setDebugBar((prev) => [
                    ...prev,
                    { name: `${prev.length + 1} ${name}`, externalCalls },
                ]);
        },
        [setDebugBar]
    );
};

export const useDebugBarData = () => useAtomValue(debugBarAtom);

export const useClearDebugBar = () => {
    const setDebugBar = useSetAtom(debugBarAtom);

    return useCallback(() => {
        setDebugBar([]);
    }, [setDebugBar]);
};
